import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, message } from 'antd';
import AreasUI from './components/AreasUI';
import { 
  getAllAreas, 
  deleteArea, 
  availableArea,
  selectAreas 
} from '../../redux/slices/areas';

const { confirm } = Modal;

const AreasMain = () => {
  const dispatch = useDispatch();
  const areas = useSelector(selectAreas);
  const [loading, setLoading] = useState(false);
  const [editorVisible, setEditorVisible] = useState(false);
  const [area, setArea] = useState(null);

  useEffect(() => {
    loadAreas();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadAreas = async () => {
    setLoading(true);
    try {
      await dispatch(getAllAreas());
    } catch (error) {
      message.error('Error al cargar las áreas');
    } finally {
      setLoading(false);
    }
  };

  const openEditor = (selectedArea) => {
    setArea(selectedArea);
    setEditorVisible(true);
  };

  const closeEditor = () => {
    setArea(null);
    setEditorVisible(false);
  };

  const handleArea = (newArea) => {
    // Esta función se puede usar para manejar el área creada si es necesario
    console.log('Área creada:', newArea);
  };

  const confirmDelete = (id) => {
    confirm({
      title: '¿Estás seguro de que quieres eliminar esta área?',
      content: 'Esta acción no se puede deshacer.',
      okText: 'Sí, eliminar',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk() {
        handleDelete(id);
      },
    });
  };

  const handleDelete = async (id) => {
    try {
      const response = await dispatch(deleteArea(id));
      if (response.status === 'success') {
        message.success('Área eliminada correctamente');
      } else {
        message.error('Error al eliminar el área');
      }
    } catch (error) {
      message.error('Error al eliminar el área');
    }
  };

  const toggleAreaStatus = async (area) => {
    try {
      const newStatus = area.active === 1 ? 0 : 1;
      const areaData = {
        ...area,
        active: newStatus
      };
      const response = await dispatch(availableArea(areaData));
      return response;
    } catch (error) {
      return { status: 'error' };
    }
  };

  return (
    <AreasUI
      loading={loading}
      areas={areas}
      area={area}
      openEditor={openEditor}
      editorVisible={editorVisible}
      closeEditor={closeEditor}
      handleArea={handleArea}
      confirmDelete={confirmDelete}
      toggleAreaStatus={toggleAreaStatus}
    />
  );
};

export default AreasMain;
